import React from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import {CATEGORICAL_PALETTE} from './chartColors';

// Donut para poucas categorias (2-4) — gênero, ativos x inativos etc.
// A ordem das cores segue sempre os primeiros slots da paleta categórica.
export default function DonutChart({data, dataKey, nameKey, height = 260, valueFormatter}) {
    return (
        <ResponsiveContainer width="100%" height={height}>
            <PieChart>
                <Pie data={data} dataKey={dataKey} nameKey={nameKey} innerRadius="55%" outerRadius="80%" paddingAngle={2}>
                    {data.map((_, index) => (
                        <Cell key={index} fill={CATEGORICAL_PALETTE[index % CATEGORICAL_PALETTE.length]} stroke="#fcfcfb" strokeWidth={2}/>
                    ))}
                </Pie>
                <Tooltip formatter={(value) => (valueFormatter ? valueFormatter(value) : value)}/>
                <Legend/>
            </PieChart>
        </ResponsiveContainer>
    );
}
